var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"slide-fade"}},[(_vm.show)?_c('div',{staticClass:"mobileNav_container"},_vm._l((_vm.menuLists),function(menu){return _c('div',{key:menu.path,staticClass:"pMenus",attrs:{"data-path":menu.path},on:{"click":function($event){return _vm.setActive(menu.path)}}},[_vm._v(_vm._s(menu.label))])}),0):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }